import type { User } from '@/api/endpoints';

const KB_EDITOR_ROLES = new Set(['admin', 'developer', 'manager', 'senior_specialist']);

export const canManageKnowledgeArticles = (user?: Pick<User, 'role'> | null): boolean =>
  !!user?.role && KB_EDITOR_ROLES.has(user.role);
